export default __webpack_public_path__ + "static/media/afr_icon.44bddd90.jpeg";